import { registerHandler } from '@/utils/queues/pc-queues'

export const registerCarouselComponent = (): void => {
  registerHandler(
    'component.carousel',
    () =>
      import(
        /* webpackChunkName: "@/components/carousel" */ '@/components/carousel'
      )
  )
}
